export const GET_MACHINE_REQUEST = "GET_MACHINE_REQUEST";
export const GET_MACHINE_SUCCESS = "GET_MACHINE_SUCCESS";
export const GET_MACHINE_FAILURE = "GET_MACHINE_FAILURE";
export const SET_MACHINE_ID = "SET_MACHINE_ID";
export const SCOPED_FINDING_RULE_REQUEST = "SCOPED_FINDING_RULE_REQUEST";
export const FILTERS_REQUEST = "FILTERS_REQUEST";
export const FETCH_SCOPED_FINDING_RULE_SUCCESS =
  "FETCH_SCOPED_FINDING_RULE_SUCCESS";
export const FETCH_SCOPED_FINDING_RULE_FAILURE =
  "FETCH_SCOPED_FINDING_RULE_FAILURE";
export const SIGNALS_REQUEST = "SIGNALS_REQUEST";
export const FETCH_SIGNALS_SUCCESS = "FETCH_SIGNALS_SUCCESS";
export const FETCH_SIGNALS_FAILURE = "FETCH_SIGNALS_FAILURE";
export const ANOMALY_TYPE_REQUEST = "ANOMALY_TYPE_REQUEST";
export const FETCH_ANOMALY_TYPE_SUCCESS = "FETCH_ANOMALY_TYPE_SUCCESS";
export const FETCH_ANOMALY_TYPE_FAILURE = "FETCH_ANOMALY_TYPE_FAILURE";
export const ANOMALY_RULE_REQUEST = "ANOMALY_RULE_REQUEST";
export const FETCH_ANOMALY_RULE_SUCCESS = "FETCH_ANOMALY_RULE_SUCCESS";
export const FETCH_ANOMALY_RULE_FAILURE = "FETCH_ANOMALY_RULE_FAILURE";
export const DELETED_ANOMALY_RULE_ID = "DELETED_ANOMALY_RULE_ID"
export const UPDATE_SCOPED_FINDING_RULE_SUCCESS =
  "UPDATE_SCOPED_FINDING_RULE_SUCCESS";
export const UPDATE_SCOPED_FINDING_RULE_FAILURE =
  "UPDATE_SCOPED_FINDING_RULE_FAILURE";
export const FETCH_ALL_ANOMALY_RULE_SUCCESS = "FETCH_ALL_ANOMALY_RULE_SUCCESS";
export const FETCH_ALL_ANOMALY_RULE_FAILURE = "FETCH_ALL_ANOMALY_RULE_FAILURE";
export const FETCH_RECOMMENDATION_SUCCESS = "FETCH_RECOMMENDATION_SUCCESS";
export const FETCH_RECOMMENDATION_FAILURE = "FETCH_RECOMMENDATION_FAILURE";
export const FETCH_RECOMMENDATION_REQUEST = "FETCH_RECOMMENDATION_REQUEST";
export const CREATE_NEW_RECOMMENDATION_SUCCESS =
  "CREATE_NEW_RECOMMENDATION_SUCCESS";
export const CREATE_NEW_RECOMMENDATION_FAILURE =
  "CREATE_NEW_RECOMMENDATION_FAILURE";

export const FETCH_ALL_RECOMMENDATION_SUCCESS =
  "FETCH_ALL_RECOMMENDATION_SUCCESS";
export const FETCH_ALL_RECOMMENDATION_FAILURE =
  "FETCH_ALL_RECOMMENDATION_FAILURE";
export const FETCH_ALL_RECOMMENDATION_REQUEST =
  "FETCH_ALL_RECOMMENDATION_REQUEST";
export const DELETE_RECOMMENDATION_SUCCESS = "DELETE_RECOMMENDATION_SUCCESS";
export const DELETE_RECOMMENDATION_FAILURE = "DELETE_RECOMMENDATION_FAILURE";
export const CLEAR_RECOMMENDATION_STATE = "CLEAR_RECOMMENDATION_STATE";

export const GET_RECOMMENDATION_SUCCESS = "GET_RECOMMENDATION_SUCCESS";
export const GET_RECOMMENDATION_FAILURE = "GET_RECOMMENDATION_FAILURE";
export const UPDATE_RECOMMENDATION_FAILURE = "UPDATE_RECOMMENDATION_FAILURE";

export const FETCH_SELECT_FINDING_RULE_SUCCESS =
  "FETCH_SELECT_FINDING_RULE_SUCCESS";
export const FETCH_SELECT_FINDING_RULE_FAILURE =
  "FETCH_SELECT_FINDING_RULE_FAILURE";
export const CREATE_NEW_FINDING_RULE_SUCCESS =
  "CREATE_NEW_FINDING_RULE_SUCCESS";
export const CREATE_NEW_FINDING_RULE_FAILURE =
  "CREATE_NEW_FINDING_RULE_FAILURE";
export const FETCH_SCOPED_FINDING_RULE_TO_DELETE_SUCCESS =
  "FETCH_SCOPED_FINDING_RULE_TO_DELETE_SUCCESS";
export const FETCH_SCOPED_FINDING_RULE_TO_DELETE_FAILURE =
  "FETCH_SCOPED_FINDING_RULE_TO_DELETE_FAILURE";
export const EDIT_FINDING_RULE_SUCCESS = "EDIT_FINDING_RULE_SUCCESS";
export const EDIT_FINDING_RULE_FAILURE = "EDIT_FINDING_RULE_FAILURE";
export const DELETE_FINDING_RULE_FAILURE = "DELETE_FINDING_RULE_FAILURE";
export const DELETE_FINDING_RULE_SUCCESS = "DELETE_FINDING_RULE_SUCCESS";

export const FETCH_UPDATERECOMMENDATION_SUCCESS =
  "FETCH_UPDATERECOMMENDATION_SUCCESS";
export const FETCH_UPDATERECOMMENDATION_FAILURE =
  "FETCH_UPDATERECOMMENDATION_FAILURE";
  export const FETCH_DELETE_RECOMMENDATION_SUCCESS =
  "FETCH_DELETE_RECOMMENDATION_SUCCESS";
export const FETCH_DELETE_RECOMMENDATION_FAILURE =
  "FETCH_DELETE_RECOMMENDATION_FAILURE";
export const FETCH_DELETE_SELECT_FINDING_RULE_SUCCESS =
  "FETCH_DELETE_SELECT_FINDING_RULE_SUCCESS";
export const FETCH_DELETE_SELECT_FINDING_RULE_FAILURE =
  "FETCH_DELETE_SELECT_FINDING_RULE_FAILURE";

export const CREATE_ANOMALY_RULE_SUCCESS = "CREATE_ANOMALY_RULE_SUCCESS";
export const CREATE_ANOMALY_RULE_FAILURE = "CREATE_ANOMALY_RULE_FAILURE";
export const DELETE_ANOMALY_RULE_SUCCESS = "DELETE_ANOMALY_RULE_SUCCESS";
export const DELETE_ANOMALY_RULE_FAILURE = "DELETE_ANOMALY_RULE_FAILURE";
export const UPDATE_SELECTED_ENTITIES = "UPDATE_SELECTED_ENTITIES";

export const CREATE_SCOPED_ANOMALY_RULE_SUCCESS =
  "CREATE_SCOPED_ANOMALY_RULE_SUCCESS";
export const CREATE_SCOPED_ANOMALY_RULE_FAILURE =
  "CREATE_SCOPED_ANOMALY_RULE_FAILURE";
export const FETCH_SELECT_SCOPED_ANOMALY_RULE_REQUEST =
  "FETCH_SELECT_SCOPED_ANOMALY_RULE_REQUEST";
export const FETCH_SCOPED_ANOMALY_RULE_SUCCESS =
  "FETCH_SCOPED_ANOMALY_RULE_SUCCESS";
export const FETCH_SCOPED_ANOMALY_RULE_FAILURE =
  "FETCH_SCOPED_ANOMALY_RULE_FAILURE";
export const DELETE_SCOPED_ANOMALY_RULE_SUCCESS =
  "DELETE_SCOPED_ANOMALY_RULE_SUCCESS";
export const DELETE_SCOPED_ANOMALY_RULE_FAILURE =
  "DELETE_SCOPED_ANOMALY_RULE_FAILURE";
export const UPDATE_SCOPED_ANOMALY_RULE_SUCCESS =
  "UPDATE_SCOPED_ANOMALY_RULE_SUCCESS";
export const UPDATE_SCOPED_ANOMALY_RULE_FAILURE =
  "UPDATE_SCOPED_ANOMALY_RULE_FAILURE";
export const FETCH_MACHINE_TYPES_SUCCESS = "FETCH_MACHINE_TYPES_SUCCESS";
export const FETCH_MACHINE_TYPES_FAILURE = "FETCH_MACHINE_TYPES_FAILURE";
export const FETCH_CUSTOMER_TYPES_SUCCESS = "FETCH_CUSTOMER_TYPES_SUCCESS";
export const FETCH_CUSTOMER_TYPES_FAILURE = "FETCH_CUSTOMER_TYPES_FAILURE";
export const FETCH_FACTORY_TYPES_SUCCESS = "FETCH_FACTORY_TYPES_SUCCESS";
export const FETCH_FACTORY_TYPES_FAILURE = "FETCH_FACTORY_TYPES_FAILURE";
export const FETCH_SERIALNUMBER_TYPES_SUCCESS =
  "FETCH_SERIALNUMBER_TYPES_SUCCESS";
export const FETCH_SERIALNUMBER_TYPES_FAILURE =
  "FETCH_SERIALNUMBER_TYPES_FAILURE";
export const FETCH_SCOPE_LIST_REQUEST = "FETCH_SCOPE_LIST_REQUEST";
export const FETCH_SCOPE_LIST_SUCCESS = "FETCH_SCOPE_LIST_SUCCESS";
export const FETCH_SCOPE_LIST_FAILURE = "FETCH_SCOPE_LIST_FAILURE";
export const EDIT_SCOPE_LIST_SUCCESS = "EDIT_SCOPE_LIST_SUCCESS";
export const EDIT_SCOPE_LIST_FAILURE = "EDIT_SCOPE_LIST_FAILURE";
export const DELETE_SCOPED_FINDING_SUCCESS = "DELETE_SCOPED_FINDING_SUCCESS";
export const DELETE_SCOPED_FINDING_FAILURE = "DELETE_SCOPED_FINDING_FAILURE";

// selectScopedAnomalyRule Constant

export const FETCH_SELECT_SCOPED_ANOMALY_RULE_SUCCESS =
  "SELECT_SCOPED_ANOMALY_RULE_SUCCESS";
export const FETCH_SELECT_SCOPED_ANOMALY_RULE_FAILURE =
  "SELECT_SCOPED_ANOMALY_RULE_FAILURE";
export const CREATE_NEW_SCOPED_FINDING_SUCCESS =
  "CREATE_NEW_SCOPED_FINDING_SUCCESS";
export const CREATE_NEW_SCOPED_FINDING_FAILURE =
  "CREATE_NEW_SCOPED_FINDING_FAILURE";
export const CLEAR_SCOPED_ANOMALY_STATE = "CLEAR_SCOPED_ANOMALY_STATE";
export const CLEAR_ANOMALY_STATE = "CLEAR_ANOMALY_STATE";
export const CLEAR_ANOMALY_RULE = "CLEAR_ANOMALY_RULE";
export const CLEAR_ANOMALY_SEARCH_FILTERS = "CLEAR_ANOMALY_SEARCH_FILTERS";
export const CLEAR_CURRENT_SIGNALS = "CLEAR_CURRENT_SIGNALS";
export const PERSIST_ANOMALY_RULE = "PERSIST_ANOMALY_RULE";
export const PERSIST_FINDING_RULE = "PERSIST_FINDING_RULE";
export const PERSIST_FILTER_DATA = "PERSIST_FILTER_DATA";
export const PERSIST_ANOMALY_RULE_FILTER = "PERSIST_ANOMALY_RULE_FILTER";
export const FETCH_FINDING_RULE_REQUEST = "FETCH_FINDING_RULE_REQUEST";
export const FETCH_All_FINDING_RULE_SUCCESS = "FETCH_All_FINDING_RULE_SUCCESS";
export const FETCH_All_FINDING_RULE_FAILURE = "FETCH_All_FINDING_RULE_FAILURE";
export const FETCH_SELECT_FINDING_FIELD_SUCCESS =
  "FETCH_SELECT_FINDING_FIELD_SUCCESS";
export const FETCH_SELECT_FINDING_FIELD_FAILURE =
  "FETCH_SELECT_FINDING_FIELD_FAILURE";
export const HMI_REQUEST = "HMI_REQUEST";
export const FETCH_HMI_SUCCESS = "FETCH_HMI_SUCCESS";
export const FETCH_HMI_FAILURE = "FETCH_HMI_FAILURE";
export const NODE_REQUEST = "NODE_REQUEST";
export const FETCH_NODE_SUCCESS = "FETCH_NODE_SUCCESS";
export const FETCH_NODE_FAILURE = "FETCH_NODE_FAILURE";
export const FUNCTION_REQUEST = "FUNCTION_REQUEST";
export const FETCH_FUNCTION_SUCCESS = "FETCH_FUNCTION_SUCCESS";
export const FETCH_FUNCTION_FAILURE = "FETCH_FUNCTION_FAILURE";
export const FETCH_SPECIFIC_ANOMALY_RULE = "FETCH_SPECIFIC_ANOMALY_RULE";
export const FETCH_SPECIFIC_ANOMALY_RULE_SUCCESS = "FETCH_SPECIFIC_ANOMALY_RULE_SUCCESS";
export const FETCH_SPECIFIC_ANOMALY_RULE_FAILURE = "FETCH_SPECIFIC_ANOMALY_RULE_FAILURE";
export const CLEAR_SPECIFIC_ANOMALY_RULE = "CLEAR_SPECIFIC_ANOMALY_RULE";
export const FETCH_ANOMALY_HMI_SUCCESS = "FETCH_ANOMALY_HMI_SUCCESS";
export const FETCH_ANOMALY_HMI_FAILURE = "FETCH_ANOMALY_HMI_FAILURE";
export const FETCH_ANOMALY_NODE_SUCCESS = "FETCH_ANOMALY_NODE_SUCCESS";
export const FETCH_ANOMALY_NODE_FAILURE = "FETCH_ANOMALY_NODE_FAILURE";
export const FETCH_ANOMALY_FUNCTION_SUCCESS = "FETCH_ANOMALY_FUNCTION_SUCCESS";
export const FETCH_ANOMALY_FUNCTION_FAILURE = "FETCH_ANOMALY_FUNCTION_FAILURE";
export const SELECT_ANOMALY_RULE_PAGE = "SELECT_ANOMALY_RULE_PAGE";
export const SET_LOADING = "SET_LOADING";
export const SET_TYPE_FILTERS = "SET_TYPE_FILTERS";
export const CLEAR_TYPE_FILTERS = "CLEAR_TYPE_FILTERS";
export const SET_BREADCRUMB = "SET_BREADCRUMB";
export const SET_BREADCRUMB_SEARCH = "SET_BREADCRUMB_SEARCH";
export const CLEAR_TYPE_HMI = "CLEAR_TYPE_HMI";
export const CLEAR_TYPE_NODE = "CLEAR_TYPE_NODE";
export const CLEAR_TYPE_FUNCTION = "CLEAR_TYPE_FUNCTION"; 
export const CLEAR_ANOMALY_RULE_FILTER = "CLEAR_ANOMALY_RULE_FILTER"; 

